<template>
  <div class="bb-consumed">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <div class="bb-consumed-item"
         :class="{'bb-consumed-item_disabled': disabled}"
         v-for="(comment, index) in commentsList"
         :key="'consumedComment' + index">
      <template v-if="disabled">
        <div class="bb-consumed-item__amount bb-consumed-item__amount_disable">
          {{convertNumber(comment.consumedAmount)}}
        </div>
        <div class="bb-consumed-item__comments">
          {{comment.consumedComment}}
        </div>
      </template>
      <template v-else>
        <input type="text"
               :disabled="disabled"
               placeholder="Amount"
               @focus="setFocusAmount(index)"
               @input="changeInput(index)"
               class="bb-input bb-input_border bb-consumed-item__amount"
               v-model="comment.consumedAmount">
        <input type="text"
               :disabled="disabled"
               placeholder="Comment"
               @input="changeInput()"
               class="bb-input bb-input_border bb-consumed-item__comments"
               v-model="comment.consumedComment">
      </template>
        <Upload class="bb-consumed-item__upload"
                v-if="displayUpload(comment)"
                :multiple="true"
                :popupDown="index !== copyRows.length -1"
                :files="comment.uploadFile"
                :view="comment.uploadFile && comment.uploadFile.length > 0"
                :upload="!disabled"
                :item="comment"
                @statusUpload="setDisabledSave"
                @view="openFile"
                @delete="deleteFile"
                @upload="uploadAllFiles"/>
      <div v-if="!disabled">
        <div class="bb-consumed-item-add"
             :class="{'bb-consumed-item-add_disabled': disabledAdd}"
             @click.stop="addComment()"
             v-if="index === commentsList.length - 1">
          <i class="icon-cross bb-consumed-item-add__icon"/>
        </div>
        <div class="bb-consumed-item-add"
             :class="{'bb-consumed-item-add_disabled': disabledAdd}"
             @click.stop="removeComment(index)"
             v-else>
          <i class="icon-minus bb-consumed-item-add__minus"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import convertNumber from '@/mixin/convertNumber'
import validateNum from '@/mixin/validateNum'
import {findIndex, get, set, uniqueId, forEach} from 'lodash'
import Upload from '@/components/Main/Upload/Upload'
import UploadFileApi from '@/api/UploadFile/api'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'ConsumedInvoice',
  props: ['comments', 'disabled', 'row', 'column', 'copyRows', 'disabledAdd'],
  mixins: [validateNum, convertNumber],
  components: {
    Upload,
    LoaderFly
  },
  data () {
    return {
      commentsList: [
        {
          consumedComment: '',
          consumedAmount: 0,
          uploadFile: []
        }
      ],
      crypt: true,
      files: {},
      loaderRun: false
    }
  },
  methods: {
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file.id)
    },
    getFile (id) {
      this.loaderRun = true
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    uploadAllFiles (files, comment) {
      if (!Array.isArray(comment.uploadFile)) comment.uploadFile = []
      forEach(files, file => {
        const fileId = uniqueId('file_')
        comment.uploadFile.push({$id: fileId, label: file.name})
        this.uploadFile(this.setFileData(file), comment, fileId)
      })
    },
    uploadFile (fileData, comment, fileId) {
      const fileIndex = findIndex(comment.uploadFile, {$id: fileId})
      UploadFileApi.createFile(fileData, this.crypt)
        .then((resp) => {
          if (fileIndex === -1) return
          comment.uploadFile.splice(fileIndex, 1, resp.data)
          this.changeInput()
        })
        .catch((err) => {
          if (fileIndex !== -1) {
            comment.uploadFile.splice(fileIndex, 1)
          }
          console.error(err)
        })
    },
    setFileData (file) {
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', file.name || '')
      fileData.set('file', file)
      return fileData
    },
    deleteFile (fileId, comment) {
      UploadFileApi.deleteFile(fileId, this.crypt)
        .then((resp) => {
          const fileIndex = findIndex(comment.uploadFile, {id: fileId})
          if (fileIndex === -1) return
          comment.uploadFile.splice(fileIndex, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setDisabledSave (val) {
      this.$emit('setDisabledUpdate', val)
    },
    displayUpload (comment = {}) {
      const hasProp = comment.uploadFile
      const hasFiles = hasProp && comment.uploadFile.length > 0
      return hasFiles || !this.disabled
    },
    validateInputs () {
      return this.commentsList.map(item => {
        const strAmount = String(item.consumedAmount)
        const point = [...strAmount.matchAll(/(\.)/gm)]
        const toManyPoints = point.length > 1
        const index = toManyPoints ? point[1].index : 0
        if (toManyPoints && point[1].index) {
          item.consumedAmount = strAmount.slice(0, index) + strAmount.slice(index + 1)
        }
        const amount = String(item.consumedAmount).replace(/[^0-9|.]+/gmi, '')
        item.consumedAmount = amount
        return item
      })
    },
    getReduceAmount (array) {
      return array.reduce((sum, acc) => sum + this.validateNum(acc.consumedAmount), 0)
    },
    checkBalance (index) {
      const allAmount = this.getReduceAmount(this.commentsList)
      const currentAmount = get(this.commentsList[index], 'consumedAmount', 0)
      const amountWithoutLast = allAmount - currentAmount
      const params = this.row.newMode ? {newMode: true} : {id: this.row.id}
      const indexRow = findIndex(this.copyRows, params)
      const copyRow = this.copyRows[indexRow]
      const balance = get(copyRow, 'amount', 0)
      if (allAmount > balance) {
        const availableAmount = balance - amountWithoutLast
        set(this.commentsList[index], 'consumedAmount', availableAmount)
      }
      return allAmount <= balance
    },
    setFocusAmount (index) {
      if (this.commentsList[index].consumedAmount === 0) {
        this.commentsList[index].consumedAmount = ''
      }
    },
    changeInput (index) {
      if (this.checkBalance(index)) {
        this.$emit('update', this.row, this.column, this.validateInputs())
      }
    },
    addComment () {
      this.commentsList.push({
        consumedComment: '',
        consumedAmount: 0,
        uploadFile: []
      })
    },
    removeComment (index) {
      this.commentsList.splice(index, 1)
      this.changeInput()
    },
    setComments () {
      const array = this.comments || []
      const defaultComment = {
        consumedComment: '',
        consumedAmount: 0,
        uploadFile: []
      }
      if (array.length === 0) {
        this.commentsList = this.disabled ? array : [defaultComment]
      } else {
        this.commentsList = array
      }
    }
  },
  watch: {
    comments () {
      this.setComments()
    },
    disabled () {
      this.setComments()
    }
  },
  beforeMount () {
    this.setComments()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-consumed {
    display: grid;
    grid-gap: 15px;
    max-width: 100%;

    &-item {
      display: grid;
      grid-template-columns: auto 1fr 21px 30px;
      grid-gap: 10px;
      justify-content: center;
      align-items: center;
      transition: 0.3s;

      &_disabled {
        grid-template-columns: auto 1fr 21px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &__amount {
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 30px;
        width: 95px;

        &_disable {
          padding: 0 6px;
        }
      }

      &__comments {
        padding: 0 10px;
        width: 100%;

        &_disabled {
          padding: 0 11px;
        }
      }

      &__upload {
        display: flex;
        height: 21px;
        width: 21px;
        justify-content: center;
        align-items: center;
      }

      &-add {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid $color-wild-sand;
        box-sizing: border-box;
        border-radius: 5px;
        min-width: 30px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        flex-basis: 30px;

        &:hover &__icon {
          color: $color-accent-hover;
        }

        &:hover &__minus {
          color: $color-accent-hover;
        }

        &__icon {
          color: $color-accent;
          transform: rotate(45deg);
        }

        &__minus {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2px;
          color: $color-accent;
        }

        &_disabled {
          pointer-events: none;

          i {
            color: $color-silver-chalice;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Table/ConsumedInvoice/ConsumedInvoice.vue